import React, { useEffect, useState } from 'react';
import '../../styles/accountForms.css';

// pages
import LoggedInAlumniProfile from '../Alumni/LoggedInAlumniProfile';
import Login from './Login';
import SignUp from './SignUp';
import ResetPassword from './ResetPassword';

export default function Account(props) {
    const [screen, setScreen] = useState(null);
    // const [loggedIn, setLoggedIn] = useState(false);
    // const [alumniData, setAlumniData] = useState({});

    // useEffect(() => {
    //     if (props?.alumniData) {
    //         // setAlumniData(props?.alumniData);
    //         // setLoggedIn(true);
    //         // setScreen('dashboard');
    //     }
    // }, [loggedIn, screen]);

    // handler to return view based on screen name.
    const getScreen = () => {
        // if (screen === 'dashboard') return <LoggedInAlumniProfile alumniData={alumniData} />;
        if (screen === 'signup') return <SignUp setScreen={setScreen} />;
        else if (screen === 'reset-password') return <ResetPassword setScreen={setScreen} />;
        else return <Login setScreen={setScreen} />;
    };

    return <div className='login-signup-container'>{getScreen()}</div>;
}
